export const APP_NAME = process.env.APP_NAME